import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { AppointmentCancellationReason } from '@/types/scheduling-api';

/**
 * GET /api/Appointment/SearchValueSets?SearchText=&SearchFor=AppointmentCancellationReason&IsForProvider=true
 *
 * Returns the picklist that drives the Cancel-Appointment dialog's reason
 * dropdown. Mirrors Flutter's `appointmentValueSets` (common_data_source_impl.dart:436)
 * dispatched from scheduling_bloc on FetchAppointmentCancellationReasonEvent.
 *
 * NOT the billing GetInvoiceMasterData endpoint (different shape — that one
 * is for payment-void / refund pickers).
 *
 * Cached for 30 min; value sets rarely change.
 */
export function useAppointmentCancellationReasons() {
  return useQuery({
    queryKey: ['cancellation-reasons', 'appointment'],
    queryFn: ({ signal }) =>
      get<AppointmentCancellationReason[]>(
        '/api/Appointment/SearchValueSets?SearchText=&SearchFor=AppointmentCancellationReason&IsForProvider=true',
        { signal },
      ),
    staleTime: 1000 * 60 * 30,
  });
}
